<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

const encryptedText = this.CryptoJS.AES.encrypt("Hi There!",  'secret key 123').toString()
const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto)=>{
        return this.CryptoJS.AES.encrypt(texto,  'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto)=>{
        return this.CryptoJS.AES.decrypt(texto,'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf,num_cand)=>{

        let candidato = {CPF:cpf,NUMEROINSC:num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-','')*7919;
        codigo_meio=codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0,5))*parseInt(candidato.NUMEROINSC.replace('-',''))*13 + '_'
        + String.fromCharCode(65 + parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[1]))
        + String.fromCharCode(parseInt(codigo_meio[4]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[7]%2===0? 97 : 67)+ parseInt(codigo_meio[7]))
        + '-'
        + String.fromCharCode(parseInt(codigo_meio[0]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))
        + String.fromCharCode(parseInt(codigo_meio[5]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[8]))
        + '_'
        + String.fromCharCode(parseInt(codigo_meio[2]%2===0? 97 : 67)+ parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[6]))
        + String.fromCharCode(parseInt(codigo_meio[6]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))

        return codigo_arquivo+'.pdf';
      }


      let cands = [
  {
    "num_cand": "U2FsdGVkX1+ibfG14Ks7KHBBnPR6iQ4SdZUxh8Q3dJ8=",
    "cpf": "U2FsdGVkX1/vLE1EhPIT4LZHZ8AxgTqeQg8Xpu9twmk="
  },
  {
    "num_cand": "U2FsdGVkX19YRw1vzp0ic9GB+sWYOMZ0M6ndtfU32NU=",
    "cpf": "U2FsdGVkX1/NGuM3HOrRV89nO+9VozmwSHib/Fx+CJE="
  },
  {
    "num_cand": "U2FsdGVkX19JYDzuynt1hPar0vQZADKBKMPbaN3uhPo=",
    "cpf": "U2FsdGVkX1/u89SZjAtrgCAnWwmSLURsqktmmhts66s="
  },
  {
    "num_cand": "U2FsdGVkX18qjwyl7ZKMZgFgcqhQzZAjMz4178bQ5mw=",
    "cpf": "U2FsdGVkX189ElyseKQCEPhQpp+GVSjoDUBj2ZAebtw="
  },
  {
    "num_cand": "U2FsdGVkX19FtF8H8ThykKeuHUx7EliB3oAV1jNlZ5M=",
    "cpf": "U2FsdGVkX1/9fd4vgznY02zY8kzlhq6aWX+zP+3/Zks="
  },
  {
    "num_cand": "U2FsdGVkX18HbaObrb8wJudgp5a09kofjXt69OXO1Tk=",
    "cpf": "U2FsdGVkX18xI9qKGTjSUTmFOCa2fTmuEoMXL1Xom14="
  },
  {
    "num_cand": "U2FsdGVkX1+9Ke6vzkHfMSa+wr1pSyOSdgZq+VIthFw=",
    "cpf": "U2FsdGVkX1/C2+bHZImfPtzNObWcPKx422eVrYjtPVE="
  },
  {
    "num_cand": "U2FsdGVkX19CEiMcVnWhW3hM6kAiKOb+Iw0tKjs6kDE=",
    "cpf": "U2FsdGVkX1907/S0gMopRRt2O2lzFfkmFTxMtabgtJw="
  },
  {
    "num_cand": "U2FsdGVkX1/PYLWz5CEtBOB19aE7tM86tA6l9hj/z9E=",
    "cpf": "U2FsdGVkX184Qdv2r/VnZXwRiSGSPgdB2/reyQle9Bw="
  },
  {
    "num_cand": "U2FsdGVkX1/wpj24b25oeCKfl4nPt0/fAD7AcpdGm6M=",
    "cpf": "U2FsdGVkX1/gkCPDs0vQCmjl6NGcrHdBP5+Q/xh5UPc="
  },
  {
    "num_cand": "U2FsdGVkX1/0O8xglGI2qQ513LwwoFCGfY7IesfhvBw=",
    "cpf": "U2FsdGVkX1/2YkcmEBKgS75WsizG7jVFK1k8Gdx3eAU="
  },
  {
    "num_cand": "U2FsdGVkX1/u0Z+mppRwrM1wh8kU1wJY8ZZMnBsEHmc=",
    "cpf": "U2FsdGVkX1/FMmaEr2asp9DT0iFYEiQPoKrrU9zAaBQ="
  },
  {
    "num_cand": "U2FsdGVkX183Bc64DFRI5mydmRyQ9S3VVBTXhlljn+E=",
    "cpf": "U2FsdGVkX19hW+uEgKYrJtunox9Uj19wobEgQ70tLAw="
  },
  {
    "num_cand": "U2FsdGVkX1+NN2/qkgk8hCHwm46CFfkoL/JiZmjXKt8=",
    "cpf": "U2FsdGVkX1+VbFvgY0amN0K9yutWheiShzMAvHTmuig="
  },
  {
    "num_cand": "U2FsdGVkX19I2iQG0BLnhTJ/PHJGKlEt66Os0sKcGxY=",
    "cpf": "U2FsdGVkX1+itGZyy9hxHb+bw6KawPUgSZIWF91bcfc="
  },
  {
    "num_cand": "U2FsdGVkX1/4cfax9RNg/JFudxVdP0in7FLMPELvS4E=",
    "cpf": "U2FsdGVkX18whMToFozsLJMEhiC1FzaWHI+hNjeVAVw="
  },
  {
    "num_cand": "U2FsdGVkX1/vh6QpyzXEGGkR7rvyLmyQ5x4sXXickVg=",
    "cpf": "U2FsdGVkX1/j32/4wvCsku9rknmiKmL9I4qf/1RBxII="
  },
  {
    "num_cand": "U2FsdGVkX19jhm6jECjvXoO1STg7zVobYaTR7Mbxdyc=",
    "cpf": "U2FsdGVkX1+pYkaoD79eJTe/CRXlyxgGRqdjh8lzmqg="
  },
  {
    "num_cand": "U2FsdGVkX18jMudvgIh+mg/rRe6jDxbckOCmZDNdhto=",
    "cpf": "U2FsdGVkX1/lZDRz+zpmC0OMTNXmmP2wLsasZ5pGrmM="
  },
  {
    "num_cand": "U2FsdGVkX1+jNjJACQnICEJ7afWplXINp6g0rcmht2A=",
    "cpf": "U2FsdGVkX1/LwVsXMQMh0HtoI9Uto8CvB7Ud/t0pNhc="
  },
  {
    "num_cand": "U2FsdGVkX19glW1oNRpu11l82aYngI5FoeCMo536Xnk=",
    "cpf": "U2FsdGVkX19G0jpyOFqM19iwUgSZk/T8wNzZoy2evhE="
  },
  {
    "num_cand": "U2FsdGVkX1/CZz3zRJZ5J9PXF2kyAm+a2DSyiGDMcOo=",
    "cpf": "U2FsdGVkX1+rR2C1kJ8V+8Ca9tk7moZHtZGnqF6uqig="
  },
  {
    "num_cand": "U2FsdGVkX19J5iXnFzslJO0F3609arxGVAXBuGQ+nbg=",
    "cpf": "U2FsdGVkX1/ZraqctNEA8Jg2en0PGblmCTn0tbekkVk="
  },
  {
    "num_cand": "U2FsdGVkX1+kGJuFNlFCW/F3LanJQmZGWiOY5zJzwJY=",
    "cpf": "U2FsdGVkX18wu9kFMDgDD0UWLItyJAu6geZhuNFjMTY="
  },
  {
    "num_cand": "U2FsdGVkX1/dDyeecGrU5ep5jq4KaJIYpQ1ZiEwNC+U=",
    "cpf": "U2FsdGVkX1/ZFZMEEy93k7Ro+hLw7dIQplalXPeZsiQ="
  },
  {
    "num_cand": "U2FsdGVkX1946DXZgjwpKtI+XRkIYKLi23RaqGFTpMg=",
    "cpf": "U2FsdGVkX19FB4CcmMaTQYK8Hfs2BA+95kdqZmENEUE="
  },
  {
    "num_cand": "U2FsdGVkX1+1MHhD931COP8TPuKjf7fCA70RcgQ/+e8=",
    "cpf": "U2FsdGVkX18vQQEfSa4cJS1yuOpQ3ME92Pajz/QUQ4M="
  },
  {
    "num_cand": "U2FsdGVkX18JZ6CBJ4TC9aH6sLoZ75ZDBJ7oqHb+j+c=",
    "cpf": "U2FsdGVkX1/g8GUtrVrAgp7SJ4IfheW1DY/o9wGSOGY="
  },
  {
    "num_cand": "U2FsdGVkX1/tfmNcoA6AhQXYjJyJwWprv75YIZbBj5M=",
    "cpf": "U2FsdGVkX1/kLbAasw7nSKKEo2gsbn5M5cJG7jr4e5I="
  },
  {
    "num_cand": "U2FsdGVkX1+ls49RpA98gfa0nWGz87bSa74MxyqCD2E=",
    "cpf": "U2FsdGVkX1+GtG4cBN5EmdYF+/LVgBvDU60NKuoVNcc="
  },
  {
    "num_cand": "U2FsdGVkX18ChlkfuOkTcM/FearrkmbgH1VdRAtDTO8=",
    "cpf": "U2FsdGVkX192fXvT4KwUpAPiLfqCWrqnjnbafv5t74E="
  },
  {
    "num_cand": "U2FsdGVkX1+J055xtwcHstUCKjxmEYzpfrtg/ioCmkA=",
    "cpf": "U2FsdGVkX184oEx8r+0WU/sDQtBFqICtNEu9p5t7y+U="
  },
  {
    "num_cand": "U2FsdGVkX18z+s8tTkQYhVO6nh2WBvGIBfSBGsE5xLs=",
    "cpf": "U2FsdGVkX1/K81L8FTEG83xldPmLFGDBLnLobzDTrY0="
  },
  {
    "num_cand": "U2FsdGVkX1/XsC9wzEsdG9q3S6v1JF1Hns7rPLugoaw=",
    "cpf": "U2FsdGVkX1++LbrOy1Vg4MmW3YU8QZETehHToRFRZqI="
  },
  {
    "num_cand": "U2FsdGVkX185vUDoTg0NQdcE/PIeIkJMya/NNGzQ6zM=",
    "cpf": "U2FsdGVkX1/4TSMKIbNlDr6QGORQvEbDaW865xfDoZo="
  },
  {
    "num_cand": "U2FsdGVkX18oXEbmNqzyppmh/9DMAlR6jLk1r4zK4sw=",
    "cpf": "U2FsdGVkX198Yqmc3EqCUXpT3zoAwFt4fovzp54Cwp8="
  },
  {
    "num_cand": "U2FsdGVkX18VhXxc/lH2grBArPqqwOQBgh/pi9rzjQE=",
    "cpf": "U2FsdGVkX1/9s5BYRMq4NBx74jWQlVlGEFx79caimfo="
  },
  {
    "num_cand": "U2FsdGVkX1/ggzysAvnMs914FdH3pOBu0v5nuieDYGY=",
    "cpf": "U2FsdGVkX1/d8Q49DnuDKn2sRos60oUr5wcbli2I2cQ="
  },
  {
    "num_cand": "U2FsdGVkX189cVypokdJ6US6uT9ZYRMblFVOVXi6eGo=",
    "cpf": "U2FsdGVkX1+WfD0JY9oMr3F5QhIrCaahd4rgdUHtGYQ="
  },
  {
    "num_cand": "U2FsdGVkX1/iLzF88j9hjg9P/cA+g46MnjlEflBlh+U=",
    "cpf": "U2FsdGVkX1/UWQ7DgL1shgHFyu8EHaH+9I4W+MvldBE="
  },
  {
    "num_cand": "U2FsdGVkX1+LmnokktMWLWPABzip3UlPxjF7UrX6X2g=",
    "cpf": "U2FsdGVkX18qSshHdG+JO0wusduME8pl7YerPEjwIn4="
  },
  {
    "num_cand": "U2FsdGVkX19XlZ8aDd8RFfakU69Wj8paDI/Udfe0Y0Q=",
    "cpf": "U2FsdGVkX18mrmtfHOggVJzNrpZdIYRmzpC8Pv7dlCg="
  },
  {
    "num_cand": "U2FsdGVkX1+jTKxyS9ZX22IgmcevRn+d3TP+8J8SgOE=",
    "cpf": "U2FsdGVkX18RYmRYaD73FD+UQeF9eF8S6YagFwBUaFc="
  },
  {
    "num_cand": "U2FsdGVkX1++pyRbl8BG1nppxHSIQcbYTvXKS7rRmwI=",
    "cpf": "U2FsdGVkX18SaTAisAczFENxmNNE2MqucLWfCWxIHOw="
  },
  {
    "num_cand": "U2FsdGVkX1+61VnMDaXpSt4ASdHvQ0tReXPq+RzYQUQ=",
    "cpf": "U2FsdGVkX19L8kehDqtQbij664WTvRMY5RjOMt3bY4Y="
  },
  {
    "num_cand": "U2FsdGVkX1/JN5mc0vZYsMwnZCkLmM+fqRZqx/q1/KA=",
    "cpf": "U2FsdGVkX1+k75TDEGhvPlhHuzTcsUJU/VGObpAuyGY="
  },
  {
    "num_cand": "U2FsdGVkX18eY7r9PhlFOdr2U70lduIdFUjoocJ5HOg=",
    "cpf": "U2FsdGVkX1+BdS12r0gIMoaT3EurHNka+okCW2wJ6V0="
  },
  {
    "num_cand": "U2FsdGVkX1/2iVj9BN9bzwFUU1ZtpKdO+veKFHkeuyA=",
    "cpf": "U2FsdGVkX19TRpdzbJahqCKsNvBAACw7BB3hiqHBEhc="
  },
  {
    "num_cand": "U2FsdGVkX183Wt3Tiigy6vLF809G3FTeHF7ytOeSB/Y=",
    "cpf": "U2FsdGVkX1+Xu2Q13bxKGvwRMROyfeF9p6/YDo0TYJc="
  },
  {
    "num_cand": "U2FsdGVkX1/8HbPi8A8f22D7fkExqjBA3X4h+tX7pWk=",
    "cpf": "U2FsdGVkX1/EbKiivBFcIuwktgdCc5yObnqsECFzpCo="
  },
  {
    "num_cand": "U2FsdGVkX188HeJ3olwVWNfUZ2dXAQuYih3L2JVx3ik=",
    "cpf": "U2FsdGVkX1+A59wxeobb1PEeIR1Zu9STgj5l0HHl14c="
  },
  {
    "num_cand": "U2FsdGVkX19WncJkyNEeeQMVebdDq5f3JJgEdWK7dPo=",
    "cpf": "U2FsdGVkX19ZFsMQS6EjiPE5sgy0xVrSwGqJd1uC0xA="
  },
  {
    "num_cand": "U2FsdGVkX1+6Fn1Z9v2J2LZMkL503z9uYJMK1eVavag=",
    "cpf": "U2FsdGVkX18xWQK9SKVPaam68oyq9zn25mtRplRQhLY="
  },
  {
    "num_cand": "U2FsdGVkX19NWioO+MGjpQdlxuf5dvhgo45pcWQzFn0=",
    "cpf": "U2FsdGVkX1+n9IHwpGzsZ+xUT7UwRdb8gGFfQFzIdks="
  },
  {
    "num_cand": "U2FsdGVkX19kZCLs8WJGSgEnTxUi+uATOLgOT8GnCLk=",
    "cpf": "U2FsdGVkX1/5FRwCw9zzstertwHX9fP9IQZxmpZm53U="
  },
  {
    "num_cand": "U2FsdGVkX184oYC4PZAvFTed2caqamJflmWh7iBFC/s=",
    "cpf": "U2FsdGVkX1/WiuyX3jJlRCcc6Cx/CXK0RciMlMGA4E4="
  },
  {
    "num_cand": "U2FsdGVkX1+RPccOwkLA25DfUjD9qMS6b++Y/R3lgSI=",
    "cpf": "U2FsdGVkX182Th1lzYfXIeLpwBXwnc4Udg1SsF7ifSo="
  },
  {
    "num_cand": "U2FsdGVkX1+I6FLIDh61TijOyL3gfyst0AjoFJ9PnNE=",
    "cpf": "U2FsdGVkX1/i/3aq5tlUR9omz0XNSsz4BpSaYUCYpqM="
  },
  {
    "num_cand": "U2FsdGVkX18t/UrsjxJGZ8muz09o8VOHkckjdcRnKqg=",
    "cpf": "U2FsdGVkX1860AVUjwusoK4upHFUB4Qs6S8I2sGJdGA="
  },
  {
    "num_cand": "U2FsdGVkX1/eG63yl8aUvOzq8JSp9BGFERCquOuY+o4=",
    "cpf": "U2FsdGVkX1+Bc9wTtboBqCpZ1bQWnb6ZEz0ZLSZnmZM="
  },
  {
    "num_cand": "U2FsdGVkX19IDzQp25UJdVbHBg1Wg+T3DKTbFG/1TfY=",
    "cpf": "U2FsdGVkX1/uxnmFjdzgbhd8+Z2tXzRRrxt1adT5qq4="
  },
  {
    "num_cand": "U2FsdGVkX190Try4Ilu/Kvg6HpCfwH0XlED4xEUoqR4=",
    "cpf": "U2FsdGVkX18W5PX7NI2GkDSUdnDMTn8xHsqs4TZlubI="
  },
  {
    "num_cand": "U2FsdGVkX18VAz9dlnEoUtXQBLerrKJuy8as1Kf13fY=",
    "cpf": "U2FsdGVkX1/p7QFldnp9WO4dn9c7RH5A5tBNH74U2EI="
  },
  {
    "num_cand": "U2FsdGVkX1+DKzzdjaOe12KBXaGxVh7RFVM3+l8aGd4=",
    "cpf": "U2FsdGVkX1/4Jfmkrafb+QQurXJrkgKJDPHD2qiSjzM="
  },
  {
    "num_cand": "U2FsdGVkX1/Wn8Hjc4cGoIVSTGAb0UvzJDfEWMhn0mc=",
    "cpf": "U2FsdGVkX18o3mlWbIIjWb0MWEMo1sqjFJ+R3gJPQb8="
  },
  {
    "num_cand": "U2FsdGVkX198YrsFo4hONRWzbVxFnhZNFd7g0RuUeTo=",
    "cpf": "U2FsdGVkX197eBuFWQrONaw/LV5enYPusGwqNvNNN4w="
  },
  {
    "num_cand": "U2FsdGVkX18Rj9beqBxkZ0h8neEwK61U/tveR/fPJhE=",
    "cpf": "U2FsdGVkX18ZiOaQGGEAr5pVEGKreVflfx7mz+4zGGM="
  },
  {
    "num_cand": "U2FsdGVkX1/CAmcSsmuVVFXKLvjiPbWa1fVrAfaY2CE=",
    "cpf": "U2FsdGVkX18/zPKIVyM+7BKt38Fk8c54VMfYpzfJh3Q="
  },
  {
    "num_cand": "U2FsdGVkX19boZhypT0GIjZZUFkF8PesIALE6wFi6YU=",
    "cpf": "U2FsdGVkX19ad3/MamVofM5P1IDaBQgvREmYNbwzEN0="
  },
  {
    "num_cand": "U2FsdGVkX1+8lYXldFdoxCzetYRbCWkAznT07YhEinI=",
    "cpf": "U2FsdGVkX19CySr2JbZQQ832/j11PBWxrEIcwiDIuK4="
  },
  {
    "num_cand": "U2FsdGVkX19esWjHSHagIvsJo6cBEIQW2qdmK6hQGGI=",
    "cpf": "U2FsdGVkX18q1+SLQ05dsy/OxLuJqoxencMDnY9B/+M="
  },
  {
    "num_cand": "U2FsdGVkX1+/e7p4KHT5xrLXgO9yjCnvdc2Y9n0sufg=",
    "cpf": "U2FsdGVkX1/WZob6DXqb8nJsyBZ/ao//6+zwrkOxEjg="
  },
  {
    "num_cand": "U2FsdGVkX1+ClHsD1Dae1VTZJYZ6fhF3CqA6hfmnQJc=",
    "cpf": "U2FsdGVkX1/LuZ6kP5XCWXv815KFGkOid7AKFEADHQo="
  },
  {
    "num_cand": "U2FsdGVkX1/4WRw63HOXpwQcpOEdew/FqOBTAVbv+9Q=",
    "cpf": "U2FsdGVkX1/kfUqWIV4vToZ6xHwSMCUaRQCJJw4oEKw="
  },
  {
    "num_cand": "U2FsdGVkX18yA5ypMIqNHkGwnU9e2QeTWczHtmdxuwU=",
    "cpf": "U2FsdGVkX1/1xPRiY2t4Cz/P+zuI9rHf4h1SlRo2tg4="
  },
  {
    "num_cand": "U2FsdGVkX1/5Q0glFEe6CZIPnruTY9ICHDVexhdO/Vk=",
    "cpf": "U2FsdGVkX18iEOkjyQPXFcL8kf5EDTMDnUGFqYAuTck="
  },
  {
    "num_cand": "U2FsdGVkX1/i7JbuTjtEoZNig4GW5THpZr6CzkTnjos=",
    "cpf": "U2FsdGVkX1+1z6pxZda4yQqZiTlOY2Nz4iYxC1GnAzA="
  },
  {
    "num_cand": "U2FsdGVkX18EN+N1BK6mTSufM9xM0MSbU57vsyUfB5g=",
    "cpf": "U2FsdGVkX18rIGEfMaKDhYQ6QTiExbQUP3fNxOPXneM="
  },
  {
    "num_cand": "U2FsdGVkX1+pwydBCKLd5x6NUv2JaaUME4/V1vKsZEg=",
    "cpf": "U2FsdGVkX18vjdu2jmVmu/iftUOp8a5Vv2DJupTaUsQ="
  },
  {
    "num_cand": "U2FsdGVkX19mCGMqnlzFRGkI1AJFDHgGp8m+U3AbmZc=",
    "cpf": "U2FsdGVkX1+5eYRtWHrI5+4yK5qIz/ECWIKjRviyL7A="
  },
  {
    "num_cand": "U2FsdGVkX18JUWv4/pz1QmwNqDur2F5WKXktcCxNydM=",
    "cpf": "U2FsdGVkX1+R/Ezqzj6NNs3XPUB/5bmhBGpMNr/wGBQ="
  },
  {
    "num_cand": "U2FsdGVkX1/ETiHPTWmG1gK8wLUOdM4OR+fjkkXlpLA=",
    "cpf": "U2FsdGVkX19TLxnixMJ/mY9ywoECP9KaFSabynPKq/A="
  },
  {
    "num_cand": "U2FsdGVkX1/0jet0ExeNu4BPSXOj90241qziI0u79n8=",
    "cpf": "U2FsdGVkX186WfRX0wCUoL+u3KbFmopIi/JqSd1SAvo="
  },
  {
    "num_cand": "U2FsdGVkX18M+Ara8tldq3m82U8nn25S43rCS1k1Z5o=",
    "cpf": "U2FsdGVkX19jQs5o3gHnTFIGT/LgglqvbgRUIh2h1ak="
  },
  {
    "num_cand": "U2FsdGVkX18OU/zoa2Rq8sy6uL1vNWZtpY5g3gqppkA=",
    "cpf": "U2FsdGVkX18Xjk5PNxcUXUYQmDvl7V8XJ4jAP2GFZaM="
  },
  {
    "num_cand": "U2FsdGVkX19g0Q5xiGqpM5LcDU54HLb4aTkod/FS3+g=",
    "cpf": "U2FsdGVkX1/VBaLdSczPHJ7fzF+LDjZGqb5q/YG09VI="
  },
  {
    "num_cand": "U2FsdGVkX19JYM+jjuBxwvRLH8yMectUhiwzHVKHNBg=",
    "cpf": "U2FsdGVkX1/jxjst+KobjxZqcXSuoQ14jifpipx/P6o="
  },
  {
    "num_cand": "U2FsdGVkX1++P0/tNZK9JE/GhbsuDIlvNZLAquW3g68=",
    "cpf": "U2FsdGVkX1+XE5JyOS6CUzVCjbWmErJmhAd1wySwNCk="
  },
  {
    "num_cand": "U2FsdGVkX1/4oRNFpbl71mML0pKOe5knx1Xvuc8jd3Q=",
    "cpf": "U2FsdGVkX1/kWbSRARlvBcnmseHTqCF49V51vxg97rk="
  },
  {
    "num_cand": "U2FsdGVkX19xIAP3HUdh6K6uQ8APo+V6k8xQlFN6Abw=",
    "cpf": "U2FsdGVkX19uNBLy0cyIs2RgxaB8E0y4H+Q0h2ycB2g="
  },
  {
    "num_cand": "U2FsdGVkX1/4j980ONt2oYlhiyIPXt/P7OqM2T2Y1/4=",
    "cpf": "U2FsdGVkX1+Rcdu1iBgYpg5HNjqSWjUJLaacfA1HF8Q="
  },
  {
    "num_cand": "U2FsdGVkX1/SGaCD55rlJr4OTV6HL2DPHmhT6Ms8Z30=",
    "cpf": "U2FsdGVkX18Fg7gtvoN9FOD33e+wKKbB+mRCrEJw1v8="
  },
  {
    "num_cand": "U2FsdGVkX189dU6tUeSRDRnRzsyiZw0Vb8st5bLl/Ns=",
    "cpf": "U2FsdGVkX192+GB0+gp6KBkHfBxgf0ZkimjzuIWWjk8="
  },
  {
    "num_cand": "U2FsdGVkX18Cy+tjIFhTadi6zZBzatBxc9Ktg19Kans=",
    "cpf": "U2FsdGVkX1+EOazMGGKuL3l268b+swCS6fQE/sDfs04="
  },
  {
    "num_cand": "U2FsdGVkX195/sXEH599HY2YoyH7hBQK4VjklPs/hA8=",
    "cpf": "U2FsdGVkX1/UXkO7UR2RwzzfF8dLbvVh3817V6stdbo="
  },
  {
    "num_cand": "U2FsdGVkX18See7P5s2RHz9eVc9dGqMVTBuOJHfhur4=",
    "cpf": "U2FsdGVkX1+TcIWLdn6FSeSG1sxuOQV7waQ9Nr7kmZM="
  },
  {
    "num_cand": "U2FsdGVkX19QkWUZ+ZV5VpSu3JyOMUXU8OUe6I6yejA=",
    "cpf": "U2FsdGVkX1/z5219ynNEc6G+7ZugwFb90Iktzh6y3jE="
  },
  {
    "num_cand": "U2FsdGVkX1+c+VthFOvbWRhe4USZzVL2akKtRzXLAEo=",
    "cpf": "U2FsdGVkX1/TTNu6+3utI7Iifci+iAGCFzZYP97nhQQ="
  },
  {
    "num_cand": "U2FsdGVkX1+SbEY/1T4kR2aKM03R93WsHqlGvoMvVPU=",
    "cpf": "U2FsdGVkX1+GttOq7/bNSOmmLjfJT3V8fNtL19H3xsI="
  },
  {
    "num_cand": "U2FsdGVkX1/OlTkmeXXSxPkAt/EMsQ1GZ2e3Lwry99E=",
    "cpf": "U2FsdGVkX1+dsyY0/qftqAPplv6WhpsCzD53WPVnx0w="
  },
  {
    "num_cand": "U2FsdGVkX18vwL/6apzJproYrJuUd3z/0GH0Kd0TRLs=",
    "cpf": "U2FsdGVkX19lHwqV74T6w5XByjD8psCvzwI3A10+YXA="
  },
  {
    "num_cand": "U2FsdGVkX19uNBY3TglzBtISsaFKaNVZlEG8dfJxtso=",
    "cpf": "U2FsdGVkX1/lvpXHbWdHNHXbjs5doIdBURTCxumD/0k="
  },
  {
    "num_cand": "U2FsdGVkX18o7VHLmlF64sHL3zWVV/7KXaszpvSVlm4=",
    "cpf": "U2FsdGVkX191iIIytI/ZUo24h6XBatq8CHRXjiyAGaw="
  },
  {
    "num_cand": "U2FsdGVkX19UaYmDEe66a1QEPZnFAhJPzinHg5e1vJE=",
    "cpf": "U2FsdGVkX1/SEcBdLuMWLy5ZH7z1LB5A8o5cYB6EKPw="
  },
  {
    "num_cand": "U2FsdGVkX18Oa7pdOBNxBs/uMlUE3tgi0pcHFl0z09M=",
    "cpf": "U2FsdGVkX1+X7uyQXtV7DYrWhfiXCBXHPmcVwsqkVXw="
  },
  {
    "num_cand": "U2FsdGVkX19OXCaF+avfGI62OvsG0mUOObjlwyVNxWU=",
    "cpf": "U2FsdGVkX1+KIC0n3dsGMEYXcrTyfLF8IQ03x2Djvw0="
  },
  {
    "num_cand": "U2FsdGVkX18b6TAL9qbfa6N7lGlxpt1E+bC2tKw/TE8=",
    "cpf": "U2FsdGVkX18JrXSvAgT3rIWGuSlCnJOp/A9oRCGEVfc="
  },
  {
    "num_cand": "U2FsdGVkX1/v/mVPYOYFFXnQFJDTE1/J8oTNsb1Dsx4=",
    "cpf": "U2FsdGVkX18R1JWogxlTTtBXlpd0uHoUHjff/G7QwbY="
  },
  {
    "num_cand": "U2FsdGVkX19frBJk+iw0dX5eTYWXMYTPcMBEvuKemts=",
    "cpf": "U2FsdGVkX18g+beBxDvuz6JEc0O+S/OSZ5+uZtiYiLg="
  },
  {
    "num_cand": "U2FsdGVkX18aAWjbmNFVBXq/MAVMVB83lVRJ8LyHBEM=",
    "cpf": "U2FsdGVkX18rurdpCAFZQz8srT6uvXif6D6K9VvpT5Y="
  },
  {
    "num_cand": "U2FsdGVkX1+BxURX84XFMOo+h25KHQ2oZvWoivY7zz0=",
    "cpf": "U2FsdGVkX18umZYVBCNhKQPzYASfyvz0ZJk2+s8WMMQ="
  },
  {
    "num_cand": "U2FsdGVkX18ScW+r5kU7e0TcfhEseEcjYUHf+KRzTA0=",
    "cpf": "U2FsdGVkX19h400XmHrlAzUcYaiKQPtvkKaVMlZ/8+8="
  },
  {
    "num_cand": "U2FsdGVkX18CkFH7Qf+2EQcK4Z63b7sC50rY/Ha8xKY=",
    "cpf": "U2FsdGVkX1+ICG0Gj67zMUnTs7EBpTZEZKMQucO06l4="
  },
  {
    "num_cand": "U2FsdGVkX18qVXD8edzNpynyYiDO0HOl/36zejor/14=",
    "cpf": "U2FsdGVkX1+IHdTgE1wT9XF/pmSrqZdfW8gbwSx83Es="
  },
  {
    "num_cand": "U2FsdGVkX1/s2wf/KdieiKmZBwhYnvfnNRIGh6uf+kk=",
    "cpf": "U2FsdGVkX18TJVJEO2vkr0GPKUSC0jpKiPKLP/1k1P4="
  },
  {
    "num_cand": "U2FsdGVkX1/lu0aG6P/qOVr3a22ZBwWGU0EXZ3lyim8=",
    "cpf": "U2FsdGVkX18s+LR3wjnztsB8B/h/Apibge8BiLLOvC0="
  },
  {
    "num_cand": "U2FsdGVkX1/mhjwRzADxLjNkDR01YtEmd5ooxxBhNxQ=",
    "cpf": "U2FsdGVkX1/VXqzZG0rp3Y658ieRWyDmm8nCruc7IGI="
  },
  {
    "num_cand": "U2FsdGVkX1+uWMuY8lvo/sB/Eg9nmwALUrAZtz6SSAM=",
    "cpf": "U2FsdGVkX1927t4i/8MrpdiSrPablh2OOg0EzZI+tTE="
  },
  {
    "num_cand": "U2FsdGVkX19k6KgdvJUl/zce7AY2I/6KB3uAnhA1yOk=",
    "cpf": "U2FsdGVkX1/u5UiXRQzszZe4O5vB/4lYdehRj7Wmakk="
  },
  {
    "num_cand": "U2FsdGVkX1+koaAYHXBoH0KZFHs3MWlVc6LRwFw5LHg=",
    "cpf": "U2FsdGVkX18XUsIq6inehBCcENtRjf94TjLThopOOvg="
  },
  {
    "num_cand": "U2FsdGVkX1/5WddrwDZNQ4CN8EhfAp1//Fa0urrJW00=",
    "cpf": "U2FsdGVkX18Y5BD/yPfubv4zI13XTMQ8ftEF6noSC5k="
  },
  {
    "num_cand": "U2FsdGVkX1/UJ7JEXucJrYJj4gMrTRnr4Vo9RP2rsWg=",
    "cpf": "U2FsdGVkX1+F5/CDwrHd6rKg4bljSb/kJ5hgsYqzaQo="
  },
  {
    "num_cand": "U2FsdGVkX19NoqHQrJdc8uOCRKeTgEXashL8j4irDkM=",
    "cpf": "U2FsdGVkX18CDKCDbg+iCk0vbRr4Ho8zmc1quhfsNms="
  },
  {
    "num_cand": "U2FsdGVkX1/vtTdtUhdUazrkzhJxl886pVWv5kkR4t0=",
    "cpf": "U2FsdGVkX1+qyXluPLt8uO4bht0wL8BD4moj7uUVN68="
  },
  {
    "num_cand": "U2FsdGVkX1+PWgPjzLuW5BcqD24h9YHvJJGv0J8WOTM=",
    "cpf": "U2FsdGVkX1+7nWgDhzf6ZzYyW9+Zurg7bVZpIBmUO8c="
  },
  {
    "num_cand": "U2FsdGVkX19APNZ76nRRJ6QJmrrbZm5SOUCfTsIJS/Q=",
    "cpf": "U2FsdGVkX1/Fd5/9Uf1pJwYRlRN9hPr08fgwfdRtkWE="
  },
  {
    "num_cand": "U2FsdGVkX1/ABS9gaQk3IalUQC5wCqyn9UXOTcSy8hs=",
    "cpf": "U2FsdGVkX19QZ5NuoiZiZHEjlnWDFZcuRl5U/ZosoDg="
  },
  {
    "num_cand": "U2FsdGVkX18OBavjRrpn4oAOM9SagQnwBTSfnYxJkMo=",
    "cpf": "U2FsdGVkX1+Famw4wuizxsn/+pInYl2+1Zgx/OwlvZU="
  },
  {
    "num_cand": "U2FsdGVkX18hGtPMoOCN13jbOhh4xf6ePdDks9un9tQ=",
    "cpf": "U2FsdGVkX1+Q3HIYxxIcSpV4cYV6JbV7PcpyQRyu+4Q="
  },
  {
    "num_cand": "U2FsdGVkX18fBS3KGCqd9CPRE4Z9/VExcqphRBChTtI=",
    "cpf": "U2FsdGVkX18UXKrArqf5Ex0Dv2RvSejrU3lynDg4rbU="
  },
  {
    "num_cand": "U2FsdGVkX19bOwxqDF/O24Q8ClSbmd2es1VHLzG5eFQ=",
    "cpf": "U2FsdGVkX1+crLI17E2WX1OBoefdbnR15/niqvLBBh8="
  },
  {
    "num_cand": "U2FsdGVkX1/bhegs932YYjG6MK8v+lOPlvHzGuUqW9I=",
    "cpf": "U2FsdGVkX1/aLvQZjzVFJjRlctF/VcMltVnS0sBaUxE="
  },
  {
    "num_cand": "U2FsdGVkX1+UhMtOd2dNdOTXnNRAIKM0tvfcRbR0Npg=",
    "cpf": "U2FsdGVkX1+5n0KTcsWSjuP/u8U84R5NhN7odVq8L3U="
  },
  {
    "num_cand": "U2FsdGVkX19y0ZToe3s4pqoiaMdm3r33EHvy7fAFLBs=",
    "cpf": "U2FsdGVkX18k3I4n5vkpx5vJKbyqKtmZzUgFYt2xKVQ="
  },
  {
    "num_cand": "U2FsdGVkX19bnUvVo9X47jwM2CgFTJIPoqadJXrDSKI=",
    "cpf": "U2FsdGVkX19Xpmj6JRb74NJKV3TpF1DGYgj9ywHRBKM="
  },
  {
    "num_cand": "U2FsdGVkX1+z3TLVtrbX1g6Xg9CsB6iYrN1XUB53bcE=",
    "cpf": "U2FsdGVkX18J7MbwSA8kXeK1FnWtxAXFhAwEyRcDou8="
  },
  {
    "num_cand": "U2FsdGVkX1/Mi0Z0jfLYtHTxoj5jU/MODTLNIhPLmwE=",
    "cpf": "U2FsdGVkX1+JPEMmoTNy6GmVgetai5IuTuThORpT5uU="
  },
  {
    "num_cand": "U2FsdGVkX19sQvS0g3ubpx0ZhQHEl7GAtoW2XDuaY6E=",
    "cpf": "U2FsdGVkX1+yKhCn36i1ujGC/wR+2LrSyc+0WszlC6c="
  },
  {
    "num_cand": "U2FsdGVkX1/Aa5mvrAhG1bp5AZzIPAcAelPrtjNfirE=",
    "cpf": "U2FsdGVkX18ShOctjsksiA0zKmyauMsyUoqitnd7kuQ="
  },
  {
    "num_cand": "U2FsdGVkX19oCCGVXeT+1SHqfn+xrG93Vg5pfkNuWNY=",
    "cpf": "U2FsdGVkX19xU26n9KxfgL/kuNcIYJUwGHXNCFKNHco="
  },
  {
    "num_cand": "U2FsdGVkX1/P6GzEUQWZH6RdJj6pnQ2yWQ9qgOol840=",
    "cpf": "U2FsdGVkX1/eZYr12Gnan3kvc/NbPHBLwTiaf4hrWBA="
  },
  {
    "num_cand": "U2FsdGVkX18p5s4TzEBBYdMG1iM0ADGlckGAw5Bud9A=",
    "cpf": "U2FsdGVkX1+W965N+Abnww6rVUu5M6ZV9mEaFuOTwD8="
  },
  {
    "num_cand": "U2FsdGVkX1/24mwFxg/nsVQfG3lTWAZtEazTnEpxCbE=",
    "cpf": "U2FsdGVkX18tyD69cGZl4pHpxeLoKUH/ZQCV/j2v5FU="
  },
  {
    "num_cand": "U2FsdGVkX1+8uwyxCXOPZY82973b36nRbLFvNc1/3Gs=",
    "cpf": "U2FsdGVkX1+VzQt3k/sNhR6ivmrxCoQHnOxZckOgpTA="
  },
  {
    "num_cand": "U2FsdGVkX180BeC3m2g1BP/mJbrr8ah8FKvP5rm+LVE=",
    "cpf": "U2FsdGVkX1+n/q+blx8fz7TpT52bGSDJx024ef2U/sg="
  },
  {
    "num_cand": "U2FsdGVkX1832af9KeqJlS16C0JeytW85vnCit77LEY=",
    "cpf": "U2FsdGVkX18ULjTcc8zPwBMn397DkYzas0pN54Ao5V0="
  },
  {
    "num_cand": "U2FsdGVkX1/yZZCCceJ+XDzIfogXUbutw/Y2BrJ7AqU=",
    "cpf": "U2FsdGVkX19kho00jM6AhF59AD5PpgD6/DZUCwRnBD4="
  },
  {
    "num_cand": "U2FsdGVkX18QfRoAX59d5HcCjdDQ7s5XcgeffuTVmhs=",
    "cpf": "U2FsdGVkX19pW+x5uvS2fDUDzifCmr/o6tlQ7uc+sEQ="
  },
  {
    "num_cand": "U2FsdGVkX1/QJ/lqrVYV5SfyoQv04TDF0P2cnaVpmWA=",
    "cpf": "U2FsdGVkX19nn46DK2vpbhfefTeHT08DKdEc8VsuCEU="
  },
  {
    "num_cand": "U2FsdGVkX1+g7rDBXcpUNNUrz1T/tVl2ZJ2mz66XC+Q=",
    "cpf": "U2FsdGVkX19ThjDC5s6WutzD8tNv+pCjoWzbS4Pkogg="
  },
  {
    "num_cand": "U2FsdGVkX18BQyvUja5OjDSyHbfz0AW9zTzONvzR4ss=",
    "cpf": "U2FsdGVkX1/KHkvE3klunPwUJ4NKYZv8arcVOdJGBUA="
  },
  {
    "num_cand": "U2FsdGVkX1/71XXrToIi8Olg4H2Y839Jr04YRgCgZMk=",
    "cpf": "U2FsdGVkX1/5e+rsi0cVMSYmGsSGlZXKi7pWR08+p/M="
  },
  {
    "num_cand": "U2FsdGVkX19+x9rliXa0qjesic8kLS6210OxHWAveMs=",
    "cpf": "U2FsdGVkX1/K17vzU48l6FwPNNMoMbypCWlyD3wq5T8="
  },
  {
    "num_cand": "U2FsdGVkX1+eEXRkrL+6XxDu1Tf4YUHIkKePgIslEGE=",
    "cpf": "U2FsdGVkX1+wCsGGnXJkvZtzypQA9GY1JV3N+oCvl7Y="
  },
  {
    "num_cand": "U2FsdGVkX18gt7k3ZZ02fdL0zRoBCjQ1okBaMEEpLyI=",
    "cpf": "U2FsdGVkX1+L4hMVRiu3vkC6XIV03ulxWBxb8vVNvH8="
  },
  {
    "num_cand": "U2FsdGVkX18HkRLnblScYunogvauRW3UOto0/SlxEBg=",
    "cpf": "U2FsdGVkX1/gW6OHF5nKnQYN7PJXDSkr6J06sjGoZrY="
  },
  {
    "num_cand": "U2FsdGVkX19E1uTk1R8zSNoUD7fmk9c9lrQj7wEaxtw=",
    "cpf": "U2FsdGVkX18z8GEPkLg1QUDc0C+F5/DhImgoAU1w0TE="
  },
  {
    "num_cand": "U2FsdGVkX1+C0Acaj6wfRMX5piQlr0bZZKG312YVIQc=",
    "cpf": "U2FsdGVkX1+PWqg2xHCpmyR27hpLe0a11MiWFiuX/Fo="
  },
  {
    "num_cand": "U2FsdGVkX1/R2oaM8RRlYJy97//aN5gEYZAyLjkitJo=",
    "cpf": "U2FsdGVkX1+82A1EB0gsjzXvmk8RiT503RMGQhEcbqs="
  },
  {
    "num_cand": "U2FsdGVkX18ryarnp9NKLNdfbIhqCtXrnqhQHwpCt4M=",
    "cpf": "U2FsdGVkX1/ik/p76ZMUZP2SdxgbCLnsCvDplQzAJZU="
  },
  {
    "num_cand": "U2FsdGVkX18ooZGm6AHp0Mf8z7/IzP395Bvu84jTMjQ=",
    "cpf": "U2FsdGVkX188mkyzg1PPvv+WmxRY6Cyku0HLEN2ui6I="
  },
  {
    "num_cand": "U2FsdGVkX1/eNieb/PIe4sOS6KdH73IwD5Vw+9CsylE=",
    "cpf": "U2FsdGVkX19zy7n6e0vnAwijxvTsyePUwGN7TWmleXM="
  },
  {
    "num_cand": "U2FsdGVkX18d6v+QQZajBYUFZDbtzhD8wPYFJxTENnw=",
    "cpf": "U2FsdGVkX18rCObdtDortW/dF3/6Gb3p5/S8n2EbFaQ="
  },
  {
    "num_cand": "U2FsdGVkX1+r0cLFWfgDPyy5Da/BKZR4sh5FopDWPvE=",
    "cpf": "U2FsdGVkX19+OoyiPI5PnVMgyULlmVoss4juPgr0xRY="
  },
  {
    "num_cand": "U2FsdGVkX1+6RTdy2nG161hbhexwK26k/5n1i8Kwujo=",
    "cpf": "U2FsdGVkX19BQMRIS2gU66wfr9KI0siXWXu+Op8Asns="
  },
  {
    "num_cand": "U2FsdGVkX1/WXoBXayZeZ7sPRuiWcUtm9/Xq+r8yYgs=",
    "cpf": "U2FsdGVkX187laZufxa2s/ziOJQMgIInEMMGFHxdXrs="
  },
  {
    "num_cand": "U2FsdGVkX1+8wMSWiWIzFu6vk6S5ffKO+2SZqg8nj3Q=",
    "cpf": "U2FsdGVkX1+0wZ/GY4fjG326Y5oarXvrzjcUAekul2Q="
  },
  {
    "num_cand": "U2FsdGVkX18RtwURcgh3PLxi15VP/s9He9ueLEspsWs=",
    "cpf": "U2FsdGVkX1+wiP18/SOWp8at8pkfZ1pivU71Vz+blXI="
  },
  {
    "num_cand": "U2FsdGVkX18zpKny5Q4AOiHczOp5v12lslTWd5AyZOQ=",
    "cpf": "U2FsdGVkX1/1zNy6gFyv6SkPp5xZNhSwW/zpr2akmno="
  },
  {
    "num_cand": "U2FsdGVkX19WpMIbArvlqLHaTsd6wTq19jfxSOM/+zU=",
    "cpf": "U2FsdGVkX19nAdgpblxGpZsS7EQGS83/v5sU+Dezrks="
  },
  {
    "num_cand": "U2FsdGVkX195iefX+/DbSUEdqsxxdSka5jCDfF1xmKo=",
    "cpf": "U2FsdGVkX1/hD5zjJfeKRIw6bhTt6zDGN7hJ9QsM9PU="
  },
  {
    "num_cand": "U2FsdGVkX1+bDgqu2LY9go3qUd+AdLoMPygqgRu9PFA=",
    "cpf": "U2FsdGVkX1/NWj5a7LDroH10bfKl5yzJRqwq4fmdFOo="
  },
  {
    "num_cand": "U2FsdGVkX199uoguqh4q6TPiE/b5AI+6Kx0DenYK4qA=",
    "cpf": "U2FsdGVkX1/S2dfaMTmCLCqlzN9rL8mfiPG8BxkYSnw="
  },
  {
    "num_cand": "U2FsdGVkX19aG5lkkJJwgfxuA/TNgSeWEH38VL0DzOk=",
    "cpf": "U2FsdGVkX19fGBeWmxyhSkStWMp99BAPdtzWnPQwkJU="
  },
  {
    "num_cand": "U2FsdGVkX1/CuFXILSJsIgndqr5Wska0pYfb3QiuK6A=",
    "cpf": "U2FsdGVkX1+wN5qaizJ2W2OGktZ9It2glYLgbopDEu8="
  },
  {
    "num_cand": "U2FsdGVkX1+r6hvO3dvfuLcUNjqf5l9BRQi9kvvQNAQ=",
    "cpf": "U2FsdGVkX1/1xt5CIuuG7g9W70V6FPDzd5QjQcDm/0k="
  },
  {
    "num_cand": "U2FsdGVkX1+LS/+Ks8v9EfVaRxVhfQCbb1AvzTjRwlE=",
    "cpf": "U2FsdGVkX19tkf/rEUvn2LHqvqoITdnyTi45pkajDBk="
  },
  {
    "num_cand": "U2FsdGVkX19QPal7s7z3aApiwKPlQ+apLleknoYOJcM=",
    "cpf": "U2FsdGVkX1+m9AKm2Cb3pwYmM9iEtbB5CbhVbeC8ZQk="
  },
  {
    "num_cand": "U2FsdGVkX1+MaxBsAqKBDQMhKqUyLQshchJKbbj69ao=",
    "cpf": "U2FsdGVkX1+IJ44+R7UEeFeh/NN9DVFICA6j3+wIPjk="
  },
  {
    "num_cand": "U2FsdGVkX197f64iR4fuJiw2kg4e38YU9+J6JgfU+yc=",
    "cpf": "U2FsdGVkX19kAk3/AFm8haQR/XbbZ5rJU+WRTDvKHk0="
  },
  {
    "num_cand": "U2FsdGVkX1+brq1Z31+eSD7Hvw1GkKi2da0G2dtjcag=",
    "cpf": "U2FsdGVkX19R0TsaOLa/FSqrJhGBwDe/NWwty61HqG0="
  },
  {
    "num_cand": "U2FsdGVkX19pI9avCo+rQxc+rtVSNG/aXYjrzfiyIMA=",
    "cpf": "U2FsdGVkX1+mVJea+GkriufLKigbCvFL/dFbnTxNKXc="
  },
  {
    "num_cand": "U2FsdGVkX1/iXQErNxSDWCfFJhWcnCsvR4RwYYmcSMI=",
    "cpf": "U2FsdGVkX193CjQWDQF9Yu8XvQU7XWofu2G9qGY0slk="
  },
  {
    "num_cand": "U2FsdGVkX1+YIYMX3+cN4OhEZooLoEXX5vRYUphjers=",
    "cpf": "U2FsdGVkX193qkVitoBB6SXdmUqWLSVaSU1EoCNA75I="
  },
  {
    "num_cand": "U2FsdGVkX1/FnikXV5SA7JM8jbXjnoyXuIdo41J/sU0=",
    "cpf": "U2FsdGVkX1/nBIgOvtyMssTyn3YGRgJas6CZAPyprTI="
  },
  {
    "num_cand": "U2FsdGVkX19JWYHVSeFHCJPbgrdaxlwC5mhYDNSFC5U=",
    "cpf": "U2FsdGVkX19deW09zORYuztuDrhKgZfE5wcXJRnDphY="
  },
  {
    "num_cand": "U2FsdGVkX19vUEOmxKxE3rQ6PZmexAPg+0owWUxR8EI=",
    "cpf": "U2FsdGVkX1+DU4EXz9DJu0vNfG9X4Rmi7mcPMEuaD2c="
  },
  {
    "num_cand": "U2FsdGVkX19k1I8hWOhsPRCcNGBreV2kpwFSKvvbjkQ=",
    "cpf": "U2FsdGVkX1/qU6Nc2jAOZ/xQd80oaFmxqnr0AksPhBE="
  },
  {
    "num_cand": "U2FsdGVkX197sw+p3iHIY8P24TxH76n1tMNRnEDf+io=",
    "cpf": "U2FsdGVkX18Q9ZSyS31oZBJ3tKqhx//4gKeo5NMuGeY="
  },
  {
    "num_cand": "U2FsdGVkX1+r+1S5zad4Bpyb+qCKRIC2oKKfMfhitbQ=",
    "cpf": "U2FsdGVkX19cGcizwn/biX3Kg61VoyWre1R0OF65Ilo="
  },
  {
    "num_cand": "U2FsdGVkX18r4Zy3RmIAF9SwnVyZc+rncuKjAqPUxpQ=",
    "cpf": "U2FsdGVkX1/cx5wAhhlRhZ876dx2M3u4PWFQAz0LcWQ="
  },
  {
    "num_cand": "U2FsdGVkX1/Kcm6ecaVmtkSK78mEBmxWMrbf7wRPTPo=",
    "cpf": "U2FsdGVkX187/BZVipwYUZRo9PxITbMMIgdTcGLbuLw="
  },
  {
    "num_cand": "U2FsdGVkX1+Ag3ZJbaCfvYldQBh3ONAwqeLmAdHsZNY=",
    "cpf": "U2FsdGVkX182jVdMBG7+86tTzkanRJir7fYZEdohS+Y="
  },
  {
    "num_cand": "U2FsdGVkX19RfFz663PuKrmqgSJIBpah+PZZmueHvHI=",
    "cpf": "U2FsdGVkX1+ATd0Er5ekT8oYMtGpZ+fxovKW18zu680="
  },
  {
    "num_cand": "U2FsdGVkX1/adw0/1BUpXpBnZadTNS/P4PP14wHESaI=",
    "cpf": "U2FsdGVkX19RZ3Qs6B2vE71F5W5UwWdm06D9Ge/HFm8="
  },
  {
    "num_cand": "U2FsdGVkX1/g3etPPJSqt5g28VpkYR/2vKG6uLt6Vy4=",
    "cpf": "U2FsdGVkX1+FzXwTiRy0kebKUDu+ZdwmZLEmLnlSu54="
  },
  {
    "num_cand": "U2FsdGVkX1/c9yFk+Y5T4v3EY3VgnsXU4c9ktpv9Tno=",
    "cpf": "U2FsdGVkX18llG4XYa3iqbGBHKSnRXIMTTHXHmzyzDQ="
  },
  {
    "num_cand": "U2FsdGVkX196A/RnS39CLERGTfvVUi5oId7pw7NhpxI=",
    "cpf": "U2FsdGVkX19fvxgKB033hQJjqs1AiKIT0kcdcAQ0J7k="
  },
  {
    "num_cand": "U2FsdGVkX190YkBhCWPwJTZzvALKmkiEZX4GPzQViE8=",
    "cpf": "U2FsdGVkX1/wFV9E444JdpGbYIKQ9SRcx/KaPny2riA="
  },
  {
    "num_cand": "U2FsdGVkX19QrneFHzHTb2An9qEifyogASHtExvhnTU=",
    "cpf": "U2FsdGVkX182V3iq6vlVV721mMjn5DAvvywyJQiUoKE="
  },
  {
    "num_cand": "U2FsdGVkX1/YmmbImGDubQs8eldu1OuaA3iVr9sjvBM=",
    "cpf": "U2FsdGVkX18Ht5eJttSYcFq/QkfcDLovDyOGlGGWefU="
  },
  {
    "num_cand": "U2FsdGVkX19pNyRN+PyQhDUwVzDIRFn40p+xoYgEOH8=",
    "cpf": "U2FsdGVkX1/Zzuw9Dnq8djH4QrnlJnPpA5d6ld41cqc="
  },
  {
    "num_cand": "U2FsdGVkX19OrEsHVQlTFUMLE9j8h+/nJgmhomdfkQM=",
    "cpf": "U2FsdGVkX1/m3yzcf29PjDLIr1m0xeyBvAk0fEbjTYs="
  },
  {
    "num_cand": "U2FsdGVkX18OC0nuMlYGW13jU5b/kE5m5HLXBSVxBdE=",
    "cpf": "U2FsdGVkX197RDwwqCXgJMww44rw2s0WS2b0mYKRQn4="
  },
  {
    "num_cand": "U2FsdGVkX1+LQsLmAVCnlsWCzGS++pjT4QINBv25ibg=",
    "cpf": "U2FsdGVkX18XZcvqQiay6JB//EX4tvA8/M2p81d5qII="
  },
  {
    "num_cand": "U2FsdGVkX18JXiEf8FNMo4IaOmaEQ2zDuMMFmNgn7g4=",
    "cpf": "U2FsdGVkX18BPUW/9csStQEtfADQbghiLoPaNqOPdM4="
  }
]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
            let num_cand_decripted = decrypt(login.num_cand);
            let cpf_decripted = decrypt(login.cpf);

            // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
             let nome_arquivo = (gera_file_name(cpf_decripted,num_cand_decripted))


            // alert(`Logou`);
              let url = (`https://fs.ibfc.org.br/arquivos/2113/2113_rec_isc_las/${nome_arquivo}`)
            return window.location.replace(url);
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
